/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */
export const DATE_FORMAT_OPTION: Intl.DateTimeFormatOptions = {
	year: 'numeric',
	month: 'long',
	day: 'numeric',
};

export const DATE_FORMAT_OPTION_NUMERIC: Intl.DateTimeFormatOptions = {
	year: 'numeric',
	month: '2-digit',
	day: '2-digit',
};

export const DATE_TIME_FORMAT_OPTION: Intl.DateTimeFormatOptions = {
	year: 'numeric',
	month: 'long',
	day: 'numeric',
	hour: 'numeric',
	minute: 'numeric',
	hour12: true,
};

export const DATE_TIME_FORMAT_OPTION_RELDATE: Intl.DateTimeFormatOptions = {
	weekday:"long",
	year: 'numeric',
	month: 'long',
	day: 'numeric',
};

export const DATE_FORMAT_OPTION_NUMERIC_2DIGIT: Intl.DateTimeFormatOptions = {
	year: '2-digit',
	month: '2-digit',
	day: '2-digit',
};

export const DATE_TIME_FORMAT_OPTION_MONTH_NAME: Intl.DateTimeFormatOptions = {
	year: 'numeric',
	month: 'long',
	day: 'numeric',
};

export const DATE_TIME_FORMAT_OPTION_DATE_MONTH_NAME: Intl.DateTimeFormatOptions = {
	day: 'numeric',
	month: 'long',	
};
